import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import logo from "../../images/logo.png";

import AtualizacaoSistema from "../AtualizacaoSistema";
import LoginForm from "./LoginForm";

const API_URL = process.env.REACT_APP_API_URL;

export default function Login() {
  const [usuarioIdAtualizacao, setUsuarioIdAtualizacao] = useState(null);
  const navigate = useNavigate();

  const particlesInit = async (main) => {
    await loadSlim(main);
  };

  const handleLoginSuccess = (usuarioId) => {
    setUsuarioIdAtualizacao(usuarioId);
  };

  const handleFinalizacaoAtualizacao = () => {
    setUsuarioIdAtualizacao(null);
    navigate("/painel");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-black relative overflow-hidden px-4">
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          fullScreen: { enable: false },
          background: { color: "transparent" },
          particles: {
            color: { value: "#ffffff" },
            links: { enable: true, color: "#ffffff", distance: 150 },
            move: { enable: true, speed: 1 },
            number: { value: 50 },
            opacity: { value: 0.3 },
            shape: { type: "circle" },
            size: { value: { min: 1, max: 3 } },
          },
        }}
        className="absolute inset-0 z-0"
      />

      {usuarioIdAtualizacao ? (
        <AtualizacaoSistema
          usuarioId={usuarioIdAtualizacao}
          onFinalizado={handleFinalizacaoAtualizacao}
          apiUrl={API_URL}
        />
      ) : (
        <div
          className="relative z-10 bg-white px-8 py-12 rounded-md shadow-2xl 
                     w-[90%] sm:w-[60%] md:max-w-md min-h-[340px] 
                     border border-gray-200 text-gray-900 flex flex-col justify-center"
        >
          <div className="flex flex-col items-center mb-8 text-center">
            <img src={logo} alt="Logo" className="w-44 h-44 mb-2" />
          </div>

          <LoginForm onLoginSuccess={handleLoginSuccess} />
        </div>
      )}
    </div>
  );
}
